const fontSize = 16;

const px2rem = px => `${px / fontSize}rem`;

const height = {
  header: {
    xsmall: 70,
    small: 70,
    medium: 110,
    large: 110,
    xlarge: 110,
    xxlarge: 110,
  },
  wrapper: {
    xsmall: 258,
    small: 490,
    medium: 544,
    large: 288,
    xlarge: 290,
    xxlarge: 390,
  },
  marginBottom: {
    xsmall: 30,
    small: 30,
    medium: 45,
    large: 45,
    xlarge: 60,
    xxlarge: 60,
  }
};

export { height, px2rem };
